<template>
    <div id="company_targets">
        <div class="heading">Targets</div>

        <div class="target">
            <p>Current Value Target: {{ formatMoneyValue(targets.value) }}</p>
            <p>New Value Target: <input type="text" v-model="targetValue"></p>

            <p>Current Opportunity Target: {{ targets.opportunities }}</p>
            <p>New Opportunity Target: <input type="text" v-model="targetOpp"></p>

            <button v-on:click="updateTargets">Update</button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';

    export default {
        name: 'CompanyTargets',
        data() {
            return {
                targets: [],
                targetValue: '',
                targetOpp: ''
            }
        },
        mounted() {
            this.getTargets();
        },
        computed: {
            ...mapGetters([
                'totalAdjustedValue',
                'totalOpportunities'
            ]),
        },
        methods: {
            formatMoneyValue(value) {
                return new Intl.NumberFormat('en-GB', { 
                    style: 'currency', 
                    currency: 'GBP',
                    minimumFractionDigits: (value > 99.9 && value%1===0) ? 0 : 2,
                }).format(value);
            },
            getTargets() {
                axios.get('api/summary-board/targets')
                    .then((result) => {
                        this.targets = result.data;
                    })
                    .catch(err => console.log(err));
            },
            updateTargets() {
                let newValueTarget = this.targetValue;
                let newOppTarget = this.targetOpp;

                if (newValueTarget === '') {
                    newValueTarget = this.targets.value;
                }

                if (newOppTarget === '') {
                    newOppTarget = this.targets.opportunities;
                }

                axios.post('api/settings/targets', {
                    newValueTarget,
                    newOppTarget
                })
                    .then(() => {
                        this.getTargets();
                    })
                    .catch(err => console.log(err))
            }
        }
    }
</script>

<style lang="scss" scoped>
    #company_targets{
        .heading{
            font-size: 2.4rem;
             margin-bottom: 2rem;
        }


        .target{
            font-size: 2rem;
        }
    }
</style>